// extracted by mini-css-extract-plugin
export default {"headerContainer":"Header_headerContainer__aWKZo","headerH":"Header_headerH__RVN7A","headerDescription":"Header_headerDescription__MzqRy","headerImg":"Header_headerImg__WnO-+"};